module.exports = __webpack_public_path__ + "static/media/testaditigre.91d20008.png";